"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var types_1 = require("../../types");
var utils_1 = require("../../utils");
var YearPicker = /** @class */ (function (_super) {
    __extends(YearPicker, _super);
    function YearPicker(props) {
        var _this = _super.call(this, props) || this;
        _this._focusItemRef = function (r) {
            if (r) {
                r.focus();
            }
        };
        _this._handleChange = function (year) {
            _this.props.onChange && _this.props.onChange(0, year);
        };
        _this._handleKeyDown = function (e, rowIdx, cellIdx) {
            var _a = _this.props, yearRows = _a.yearRows, onNext = _a.onNext, onPrev = _a.onPrev, onCloseCalendar = _a.onCloseCalendar;
            var _b = _this.state, focusedCell = _b.focusedCell, focusedRow = _b.focusedRow;
            var keyCode = e.keyCode;
            if (keyCode === types_1.KeyCode.Enter || keyCode === types_1.KeyCode.Space) {
                _this._handleChange(yearRows[rowIdx][cellIdx]);
            }
            else if (keyCode === types_1.KeyCode.Tab &&
                !e.shiftKey &&
                e.target.className.indexOf('DayPicker-Year-Item') >= 0) {
                onCloseCalendar();
            }
            else if (keyCode === types_1.KeyCode.ArrowUp ||
                keyCode === types_1.KeyCode.ArrowDown ||
                keyCode === types_1.KeyCode.ArrowLeft ||
                keyCode === types_1.KeyCode.ArrowRight) {
                var newValues = utils_1.handleKeyboardNav(e, focusedRow, focusedCell, yearRows);
                _this.setState({
                    focusedCell: newValues.cell,
                    focusedRow: newValues.row
                });
                if (newValues.changePage) {
                    if (newValues.pageChangeDir === 'next') {
                        onNext();
                    }
                    else if (newValues.pageChangeDir === 'prev') {
                        onPrev();
                    }
                }
            }
        };
        _this.state = {
            focusedRow: 0,
            focusedCell: 0
        };
        return _this;
    }
    YearPicker.prototype.componentDidMount = function () {
        var _this = this;
        var yearRows = this.props.yearRows;
        var focus = {
            cell: 0,
            row: 0
        };
        yearRows.forEach(function (row, rowIdx) {
            row.forEach(function (cell, cellIdx) {
                if (_this.props.year === cell) {
                    focus.cell = cellIdx;
                    focus.row = rowIdx;
                }
            });
        });
        this.setState({
            focusedCell: focus.cell,
            focusedRow: focus.row
        });
    };
    YearPicker.prototype.render = function () {
        var _this = this;
        var _a = this.props, classNames = _a.classNames, yearRows = _a.yearRows;
        return (React.createElement("div", { className: "custom-selector year-selector" },
            React.createElement("div", { className: "DayPicker-Years", role: "grid" },
                React.createElement("div", { className: classNames.body, role: "rowgroup" }, yearRows.map(function (yearRow, rowIdx) {
                    return (React.createElement("div", { className: "DayPicker-Year-Row", role: "row", key: "year-row-" + rowIdx }, yearRow.map(function (yearItem, cellIdx) {
                        var ref;
                        var itemProps = {
                            className: 'DayPicker-Year-Item',
                            ref: ref,
                            role: 'gridcell',
                            tabIndex: -1,
                            key: "year-item-" + yearItem,
                            'aria-label': "" + yearItem,
                            'aria-selected': false,
                            onClick: function (e) {
                                e.preventDefault();
                                _this._handleChange(yearItem);
                            },
                            onKeyDown: function (e) {
                                _this._handleKeyDown(e, rowIdx, cellIdx);
                            }
                        };
                        if (yearItem === _this.props.initialDate.getFullYear()) {
                            itemProps.className = itemProps.className + " p-bg-primary50 p-br-md p-t-light selected";
                            itemProps['aria-selected'] = true;
                        }
                        if (rowIdx === _this.state.focusedRow && cellIdx === _this.state.focusedCell) {
                            itemProps.ref = function (r) { return _this._focusItemRef(r); };
                            itemProps.tabIndex = 0;
                        }
                        return React.createElement("div", __assign({}, itemProps), yearItem);
                    })));
                })))));
    };
    return YearPicker;
}(React.Component));
exports.default = YearPicker;
//# sourceMappingURL=YearPicker.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/date-picker/build/control/components/YearPicker.js
// module id = 304
// module chunks = 0 1